import { createContext } from "react";

const FlowgraphContext = createContext();
export default FlowgraphContext;
